import React from 'react';
import { Fuel, Droplets, Volume2, Snowflake } from 'lucide-react';
import { Toggle } from './TyreFormControls';
import { useT } from '../../services/i18n';

const GRADES = ['A', 'B', 'C', 'D', 'E'];
const NOISES = [[68, 'tw.eu.noiseA'], [71, 'tw.eu.noiseB'], [75, 'tw.eu.noise75']];

const GradeSelect = ({ Icon, label, value, onChange, testId, t }) => (
  <label className="flex items-center gap-1.5 text-xs text-slate-600">
    <Icon size={14} className="text-slate-400" /> {label}
    <select value={value || ''} onChange={(e) => onChange(e.target.value)} data-testid={testId} className="h-8 rounded-md border border-slate-300 bg-white px-2 text-xs font-semibold text-slate-800">
      <option value="">{t('tw.allF')}</option>
      {GRADES.map((g) => <option key={g} value={g}>{g === 'A' ? t('tw.eu.onlyA') : t('tw.eu.aTo', { g })}</option>)}
    </select>
  </label>
);

export const EMPTY_LABEL_FILTERS = { fuel: '', wet: '', noise_max: '', snowflake: false };

const EuLabelFilters = ({ value, onChange, withSnowflake = false, testIdPrefix = 'eu' }) => {
  const { t } = useT();
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid={`${testIdPrefix}-label-filters`}>
      <span className="text-[10px] font-bold uppercase tracking-wide text-slate-500">{t('tw.eu.title')}</span>
      <GradeSelect Icon={Fuel} label={t('tw.eu.fuel')} value={value.fuel} onChange={set('fuel')} testId={`${testIdPrefix}-fuel`} t={t} />
      <GradeSelect Icon={Droplets} label={t('tw.eu.wet')} value={value.wet} onChange={set('wet')} testId={`${testIdPrefix}-wet`} t={t} />
      <label className="flex items-center gap-1.5 text-xs text-slate-600">
        <Volume2 size={14} className="text-slate-400" /> {t('tw.eu.noise')}
        <select value={value.noise_max || ''} onChange={(e) => set('noise_max')(e.target.value)} data-testid={`${testIdPrefix}-noise`} className="h-8 rounded-md border border-slate-300 bg-white px-2 text-xs font-semibold text-slate-800">
          <option value="">{t('tw.allM')}</option>
          {NOISES.map(([v, k]) => <option key={v} value={v}>{t(k)}</option>)}
        </select>
      </label>
      {withSnowflake && <Toggle checked={!!value.snowflake} onChange={set('snowflake')} label={<span className="inline-flex items-center gap-1"><Snowflake size={12} /> {t('tw.eu.snowflake')}</span>} testId={`${testIdPrefix}-snowflake`} />}
    </div>
  );
};

export default EuLabelFilters;
